import { Dayjs } from 'dayjs'

export enum FormTypes {
  delivery = 'DELIVERY',
  product = 'PRODUCT',
  basket = 'BASKET'
}

export enum DiscountTypes {
  fixed = 'FIXED',
  percent = 'PERCENTAGE',
  buy_one_special = 'BUY_ONE_SPECIAL'
}

export enum BasketDiscountSteps {
  step1 = 'APPLICATION_METHOD',
  step2 = 'LOCATION_AND_FULFILMENT_TYPES',
  step3 = 'DISCOUNT_TYPE',
  step4 = 'BASKET_COMPONENTS',
  step5 = 'RESTRICTIONS',
  step6 = 'DEFINE_RULES'
}

export enum ProductDiscountSteps {
  step1 = 'APPLICATION_METHOD',
  step2 = 'LOCATION_AND_FULFILMENT_TYPES',
  step3 = 'DISCOUNT_TYPE',
  step4 = 'ELIGIBLE_PRODUCTS',
  step5 = 'RESTRICTIONS',
  step6 = 'DEFINE_RULES'
}

export enum DeliveryDiscountSteps {
  step1 = 'APPLICATION_METHOD',
  step2 = 'LOCATIONS',
  step3 = 'DISCOUNT_TYPE',
  step4 = 'RESTRICTIONS',
  step5 = 'DEFINE_RULES'
}

export enum StoreMinOrderValueRule {
  BEFORE = 'PRE_DISCOUNTED_BASKET_VALUE',
  AFTER = 'POST_DISCOUNTED_BASKET_VALUE'
}

export enum FulfillmentType {
  DELIVERY = 'DELIVERY',
  PICKUP = 'PICKUP',
  TABLE = 'ORDER_AT_TABLE'
}

export enum DiscountTarget {
  ALL_CHARGES = 'ALL_CHARGES',
  ALL_PRODUCTS = 'ALL_PRODUCTS',
  CATEGORY = 'CATEGORY',
  DELIVERY_FEE = 'DELIVERY_FEE',
  PRODUCT = 'PRODUCT',
  PRODUCT_VARIANT = 'PRODUCT_VARIANT',
  SUBTOTAL_DELIVERY_FEE = 'SUBTOTAL_DELIVERY_FEE',
  VARIANT_OR_CATEGORY = 'VARIANT_OR_CATEGORY'
}

export enum DiscountTrigger {
  MANUAL = 'MANUAL',
  AUTOMATIC = 'AUTOMATIC'
}

export enum DiscountApplicationStrategy {
  ASCENDING = 'ASC',
  DESCENDING = 'DESC'
}

export interface FormValues {
  id?: string
  store_ids: string[]
  code: string
  description?: string
  end_date?: Dayjs
  target: `${DiscountTarget}`
  trigger: `${DiscountTrigger}`
  fulfillment_types: `${FulfillmentType}`[]
  start_date?: Dayjs
  category_ids?: string[]
  product_ids?: string[]
  is_active?: boolean
  type: `${DiscountTypes}`
  store_min_order_value_rule?: `${StoreMinOrderValueRule}`
  minimum_value?: number
  published_at?: Dayjs
  quantity?: number | null
  quantity_per_customer?: number | null
  variants_only: boolean
  application_strategy: `${DiscountApplicationStrategy}`
  value_limit?: number | null
  product_limit?: number | null
  value: number | null // Required - consolidates discount_percentage/amount/buy_one_special
  discount_fixed?: number | null
  discount_percentage?: number | null
  discount_buy_one_special?: number | null
}
